import React, { useEffect, useState } from "react";

import Dropdown from "./doctype-dropdown";
import UploadBox from "./upload-box";

import "./file-upload.css";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useLocation, useNavigate } from "react-router-dom";

import Stepper from "./stepper";
import Loader from "./loader";
import ProductDropdown from "./product-dropdown";

import Greenbanner from "@/components/header/greenbanner";
import axios from "axios";

export default function Upload() {
  //get project name from dashboard
  const location = useLocation();
  const value = location.state?.traceabilty;
  const [document_data, setdocument_data] = useState([]);
  useEffect(() => {
    if (value) {
      setdocType("End to End Traceability");
    }
  }, []);
  const [docType, setdocType] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setload] = useState(false);
  const storedUserInfo = JSON.parse(localStorage.getItem("userInfo") ?? "");
  const matches = useMediaQuery("(max-width:1150px)");

  const downloadTemplate = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const gcsPath =
        "gs://feature_description_template_bucket/Feature Definition template - Updated (1).docx";

      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/download-gcs-file?gcs_path=${encodeURIComponent(gcsPath)}`,
        { gcs_path: gcsPath },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "Feature Definition template - Updated.docx"
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        console.error("Download failed:", response.status);
      }
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <Box>
      <Greenbanner name={`Welcome ${storedUserInfo.name}`} />
      {loading && <Loader textrecieved="Uploading Files" />}
      <Box sx={{ ml: 2, mr: 2, mt: 2 }}>
        <Box className="top-upload">
          <Box className="starter">
            <Typography
              variant="h6"
              sx={{ fontWeight: "bolder", fontSize: "18px" }}
            >
              Get Started here...
            </Typography>
            <Typography
              variant="h6"
              sx={{ mt: 0.5, fontSize: "16px", fontWeight: "bold" }}
            >
              Choose a type of document you would like to generate:
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: matches ? "column" : "row",
                width: "100%",
              }}
            >
              <Box sx={{ mt: 0.5, mb: 2, marginRight: "1rem" }}>
                <Dropdown
                  doctype={docType}
                  setdoctype={setdocType}
                  disabled={loading || docType === "End to End Traceability"}
                  setdocument_data={setdocument_data}
                />
              </Box>
              {docType !== "End to End Traceability" &&
                docType !== "Generate User Stories" &&
                docType !== "Generate Test Case Steps" &&
                docType !==
                  "Generate Acceptance Criteria & Expected Results" && (
                  <Box sx={{ mt: 0.5, mb: 2 }}>
                    <ProductDropdown
                      products={products}
                      setProducts={setProducts}
                      isDisabled={false}
                    />
                  </Box>
                )}
            </Box>
          </Box>
          {/* <Box className="tree-box">
            <Stepper doctype={docType} />
          </Box> */}
          <Box className="tree-box" sx={{ display: "flex", gap: 2 }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#137D00",
                color: "white",
                textTransform: "none",
                padding: "4px 8px",
                minWidth: "auto",
                height: "fit-content",
                boxShadow: "none",
                borderRadius: "6px",
                fontSize: "14px",
              }}
              onClick={downloadTemplate}
            >
              Download Template
            </Button>
            <Stepper doctype={docType} />
          </Box>
        </Box>
        {docType && docType.trim() !== "" ? (
          <Box className="UploadBox">
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                color: "#0085CA",
                fontStyle: "italic",
                mb: 1,
              }}
            >
              Note: Upload all mandatory documents here:(.pdf,.txt,.doc)
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                color: "#0085CA",
                fontStyle: "italic",
                mb: 1,
              }}
            >
              File size: supported upto 10MB
            </Typography>
            <UploadBox
              docType={docType}
              products={products || []}
              loading={loading}
              setload={setload}
              document_data={document_data}
              setdocument_data={setdocument_data}
            />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
